var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledClipboardList24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/clipboard-list_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 4.000000)",
    id: "clipboard-list",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5,2 L8,2 C8,0.896875 7.103125,0 6,0 C4.896875,0 4,0.896875 4,2 L1.5,2 C0.671875,2 0,2.671875 0,3.5 L0,14.5 C0,15.328125 0.671875,16 1.5,16 L10.5,16 C11.328125,16 12,15.328125 12,14.5 L12,3.5 C12,2.671875 11.328125,2 10.5,2 Z M3,13.25 C2.584375,13.25 2.25,12.915625 2.25,12.5 C2.25,12.084375 2.584375,11.75 3,11.75 C3.415625,11.75 3.75,12.084375 3.75,12.5 C3.75,12.915625 3.415625,13.25 3,13.25 Z M3,10.25 C2.584375,10.25 2.25,9.915625 2.25,9.5 C2.25,9.084375 2.584375,8.75 3,8.75 C3.415625,8.75 3.75,9.084375 3.75,9.5 C3.75,9.915625 3.415625,10.25 3,10.25 Z M3,7.25 C2.584375,7.25 2.25,6.915625 2.25,6.5 C2.25,6.084375 2.584375,5.75 3,5.75 C3.415625,5.75 3.75,6.084375 3.75,6.5 C3.75,6.915625 3.415625,7.25 3,7.25 Z M6,1.25 C6.415625,1.25 6.75,1.584375 6.75,2 C6.75,2.415625 6.415625,2.75 6,2.75 C5.584375,2.75 5.25,2.415625 5.25,2 C5.25,1.584375 5.584375,1.25 6,1.25 Z M10,12.75 C10,12.8875 9.8875,13 9.75,13 L5.25,13 C5.1125,13 5,12.8875 5,12.75 L5,12.25 C5,12.1125 5.1125,12 5.25,12 L9.75,12 C9.8875,12 10,12.1125 10,12.25 L10,12.75 Z M10,9.75 C10,9.8875 9.8875,10 9.75,10 L5.25,10 C5.1125,10 5,9.8875 5,9.75 L5,9.25 C5,9.1125 5.1125,9 5.25,9 L9.75,9 C9.8875,9 10,9.1125 10,9.25 L10,9.75 Z M10,6.75 C10,6.8875 9.8875,7 9.75,7 L5.25,7 C5.1125,7 5,6.8875 5,6.75 L5,6.25 C5,6.1125 5.1125,6 5.25,6 L9.75,6 C9.8875,6 10,6.1125 10,6.25 L10,6.75 Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledClipboardList24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_clipboard-list_24px.9ef70419.svg";
export { ForwardRef as ReactComponent };